export default __webpack_public_path__ + "static/media/Venky.4abb8375.jpg";